import { gql, useMutation } from '@apollo/client';
import { GenderModel, GenderCreateModelInput } from '@utmost.co/enterprise-models';
import { useSnackbar } from 'src/utils/hooks/useSnackbar';

const ADD_GENDER = gql`
  mutation AddGender($model: GenderCreateModelInput!) {
    createGender(model: $model) {
      uid
      name
      referenceId
      status
      assignable
      sourceName
    }
  }
`;

interface Output {
  addGender: (model: Partial<GenderCreateModelInput>) => Promise<void>;
  loading: boolean;
}

export const useAddGenders: () => Output = () => {
  const [addGenderMutation, { loading }] = useMutation<
    { createGender: GenderModel },
    { model: DeepPartial<GenderCreateModelInput> }
  >(ADD_GENDER);
  const { showError } = useSnackbar();

  const addGender = async (model: Partial<GenderCreateModelInput>) => {
    try {
      await addGenderMutation({ variables: { model } });
    } catch (e: any) {
      showError(e.message);
    }
  };
  return {
    addGender,
    loading
  };
};
